export const AUTH_EMAIL_SENDER_NAME = 'MindLabs at Explore';
export const AUTH_EMAIL_SENDER_ADDRESS = 'support@exploresupport.com';
export const AUTH_EMAIL_FROM = {
  email: AUTH_EMAIL_SENDER_ADDRESS,
  name: AUTH_EMAIL_SENDER_NAME,
} as const;
export const AUTH_EMAIL_REPLY_TO = AUTH_EMAIL_FROM;
export const AUTH_EMAIL_EXPECTED_SENDER = `${AUTH_EMAIL_SENDER_NAME} <${AUTH_EMAIL_SENDER_ADDRESS}>`;
export const AUTH_EMAIL_SUPPORT_COPY = `Need help? Reply to ${AUTH_EMAIL_SENDER_ADDRESS} and our team will help.`;
export const AUTH_EMAIL_SPAM_HELP = `If it does not arrive soon, check your spam folder for ${AUTH_EMAIL_EXPECTED_SENDER}.`;
